import { render, staticRenderFns } from "./third_party_platform.vue?vue&type=template&id=9df17be4&"
import script from "./third_party_platform.vue?vue&type=script&lang=js&"
export * from "./third_party_platform.vue?vue&type=script&lang=js&"
import style0 from "./third_party_platform.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports